import {Header} from "../components/Header";
import {Group} from '@mantine/core';
import {CGRTextSection} from "../components/CGRTextSection";
import {CGRNav} from "../components/CGRNav";
import {TableOfContents} from "../components/TableOfContents";

const CGRPage = () => {
    return (
        <>
            <Header/>
            <Group style={{
                display: 'flex',
                justifyContent: 'space-between'
            }}
                   align="flex-start"
                   justify="space-between"
                   wrap="nowrap"
                   gap="xl"
            >
                <TableOfContents/>
                <CGRTextSection/>
                <CGRNav/>
            </Group>
        </>
    )
}

export default CGRPage;